const de_DE = {
  restartInterviewButton: "Neu beginnen",
  restartInterviewConfirmTitle: "Ein neues Interview beginnen?",
  restartInterviewConfirmDescription: "Ein neues Interview beginnt von vorn. Ihre bisherigen Interviewaufzeichnungen bleiben erhalten.",
  restartInterviewCancel: "Abbrechen",
  restartInterviewFailed: "Das Interview konnte nicht neu gestartet werden. Bitte versuchen Sie es später erneut.",
  restartInterviewLimitReached: "Die maximale Anzahl an Interviews ist erreicht. Ein neues Interview ist nicht möglich.",
  restartInterviewClosed: "Dieses Interview ist geschlossen. Ein Neustart ist nicht möglich.",
  restartInterviewCutoff: "Die Teilnahmefrist ist abgelaufen. Ein Neustart ist nicht möglich.",
  interviewLoading: "Interview wird geladen…",
  interviewLinkInvalid: "Ungültiger Interview-Link",
  interviewLoadFailed: "Das Interview konnte nicht geladen werden. Bitte versuchen Sie es später erneut.",
  interviewRetry: "Erneut versuchen",
  saveInfoFailed: 'Ihre Angaben konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.',
  loadLatestInterviewFailed: 'Die neuesten Interviewdaten konnten nicht geladen werden. Bitte versuchen Sie es später erneut.',
  interviewProgressSaved: 'Ihr Interviewfortschritt geht nicht verloren',
  previousStimulus: 'Vorheriges Konzept',
  nextStimulus: 'Nächstes Konzept',
  expandStimulus: 'Konzept vergrößern',
  closeStimulusPreview: 'Konzeptvorschau schließen',
  stimulusPreview: 'Konzeptvorschau',
  imageTooLarge: 'Das Bild darf nicht größer als 10 MB sein',
  imageFormatJpegPngOnly: 'Nur Bilder im Format PNG, JPEG oder JPG werden unterstützt',
  imageFilesOnly: 'Es können nur Bilddateien hochgeladen werden',
  imageUploadFailed: 'Das Bild konnte nicht hochgeladen werden. Bitte versuchen Sie es erneut.',
  finalUploadFailed: 'Die Dateien konnten nicht hochgeladen werden. Bitte versuchen Sie es erneut.',
  Welcome: 'Willkommen bei der Bewerbung für',
  StartInterview: 'Interview starten',
  Submit: 'Senden',
  Stoprecording: 'Aufnahme stoppen',
  Aiinterviewer: 'Interview-Ersteller',
  AiModeratedInterview: 'KI-MODERIERTES INTERVIEW',
  TalkToAva: 'Mit Ava sprechen',
  microphoneAccessTitle: 'Mikrofonzugriff erlauben',
  microphoneAccessDescription: 'Ava benötigt dein Mikrofon für ein natürliches Sprachgespräch.',
  microphoneAllow: 'Mikrofon erlauben',
  microphoneNotNow: 'Jetzt nicht',
  microphoneConnectedTitle: 'Mikrofon verbunden',
  microphoneConnectedDescription: 'Alles bereit. Ava kann dir jetzt zuhören.',
  microphoneDeniedTitle: 'Mikrofonzugriff erforderlich',
  microphoneDeniedDescription: 'Erlaube den Mikrofonzugriff in den Browsereinstellungen und versuche es erneut.',
  microphoneTryAgain: 'Erneut versuchen',
  VoiceAnswer: 'Sprachantwort',
  TextAnswer: 'Textantwort',
  StudyMainTitle:
    'Vor dem eigentlichen Interview führen wir ein Screening durch',
  StudyMainTip:
    'Leider sind Sie nicht die Zielgruppe dieses Interviews und können an diesem Interview nicht teilnehmen',
  // ThankYou: '谢谢',
  //
  TitleTop: 'Sie sind eingeladen!',
  HeardVoice: 'Ihre Stimme ist wertvoll, wird gefördert!',
  Sophie: 'Haben Sie eine kurze Unterhaltung mit Ava',
  Sponsored: 'Sponsored by Santa Clause🎅',
  Chikkens: 'Starten Sie einen kurzen Chat und erhalten Sie exklusive',
  Dollars: 'CHIMOJI Belohnung!',
  // Progress: 'the progress of this chat',
  Congrats: 'Glückwunsch abgeschlossen!',
  ThankYou: 'Vielen Dank für Ihre Beiträge',

  Refresh: 'Auf dieser Seite neu laden wird keinen Fortschritt verlieren',
  Carousel:
    'Aufgrund der Netzwerkbedingungen kann es zu geringfügigen Verzögerungen kommen',
  CheckOut:
    'Sie möchten auch solche Interviews erstellen? Schauen Sie sich an ',
  Rewarded:
    'Wenn Sie eine Belohnung erhalten möchten, benötigt der Interviewer Ihre Informationen',
  InterviewerReward: 'Dies ist die Belohnung von Ihrem Interviewer',
  Register: 'Login/Registrieren als',
  Insighteer: 'EINBLICKE',
  Reward: 'um Ihre Belohnung zu erhalten',
  CreatePassword:
    'Erstellen Sie ein Passwort, um die Registrierung abzuschließen',
  Becoming: 'Werden Sie unsere Mitglied!',
  Password: 'Bitte geben Sie Ihr Passwort ein!',
  ChooseTopic: 'Wählen Sie ein Thema, das Ihnen interessiert',
  Identity: 'Sie sind...',
  Awesome: 'Awesome!',
  Rocks: 'FELSEN',
  Followus: 'Folgen Sie uns',
  Unique:
    'Dieser einzigartige CHIMOJI gehört zu Ihnen und wird mit dieser Interview-Session auf der Blockchain aufbewahrt',
  Next: 'Nächster Schritt',
  ViewRewards: 'Belohnungen ansehen',
  endMeg1:
    'Bitte geben Sie Ihre E-Mail-Adresse ein, damit wir Ihnen die Sprachwiedergabe senden können',
  endMeg2:
    'Bitte geben Sie Ihre Informationen ein, um die Belohnung des Interview-Erstellers zu erhalten',
  endMeg3:
    'Bitte geben Sie Ihre Informationen ein, um diese Interview-Session zu erhalten',
  endMsg5: 'Bitte geben Sie Ihre Informationen ein, um',
  endMsg6: 'Ihre MBTI-Test-Ergebnisse zu erhalten',
  Done: 'Senden',
  Done1: 'Beenden',
  GetIncentives: 'Belohnungen erhalten',
  GetStartedFreeNow: 'Jetzt kostenlos starten',
  UniqueChimojiNFT: 'Einzigartiger Chimoji NFT',
  endMsg4: 'Wollen Sie solche Interviews erstellen?',
  ResumeInterview: 'Weiter zum Interview',
  interviewPausedTitle: 'Interview pausiert',
  interviewPausedDescription: 'Dein Fortschritt wurde gespeichert. Du kannst fortfahren, wenn du bereit bist.',
  resumeInterviewButton: 'Interview fortsetzen',
  pauseInterview: 'Pausieren',
  pauseInterviewConfirmTitle: 'Interview pausieren?',
  pauseInterviewConfirmContent:
    'Ihr Fortschritt wird gespeichert. Sie können das Interview später fortsetzen.',
  pauseInterviewConfirmOk: 'Pausieren',
  pauseInterviewConfirmCancel: 'Interview fortsetzen',
  poorConnection: 'Verbindung schlecht',
  connectionReconnectingTitle: 'Wird neu verbunden…',
  connectionReconnectingDescription: 'Bitte lasse diese Seite geöffnet. Ava stellt die Verbindung wieder her.',
  connectionReconnectedTitle: 'Wieder verbunden',
  connectionReconnectedDescription: 'Die Verbindung wurde wiederhergestellt. Das Interview wird fortgesetzt.',
  connectionDisconnectedTitle: 'Verbindung verloren',
  connectionDisconnectedDescription: 'Dein Interviewfortschritt wurde gespeichert.',
  refresh: 'Seite neu laden wird keinen Fortschritt verlieren',
  voiceSnapshot: 'Sprachaufnahme',
  fromInterview: 'Von der künstlichen Intelligenz Ava zu meinem Interview',
  findMore: 'Weitere Informationen auf chikka.ai',
  msg1: 'Mit Ava sprechen, testen Sie Ihre MBTI in 5 Minuten',
  speaking: 'Sie sprechen...',
  avaSpeaking: 'Ava spricht...',
  avaListening: 'Ava hört...',
  stimuliConversationWithAva: 'Sie befinden sich in einem Gesprach mit Ava',
  stimuliReviewConcepts:
    'Bitte sehen Sie sich die folgenden Konzepte sorgfaltig an und beantworten Sie Avas Fragen.',
  stimuliSwipeInstruction:
    'Wischen Sie nach links oder rechts, um alle Konzepte zu sehen.',
  stimuliFullscreenInstruction: 'Doppelklicken Sie auf ein Bild, um es im Vollbild anzuzeigen.',
  finalUploadTitleFallback: 'Dateien hochladen',
  finalUploadInstructionFallback:
    'Fugen Sie Dateien hinzu, bevor Sie das Interview beenden',
  finalUploadTap: 'Tippen zum Hochladen',
  finalUploadHelp:
    'Ihre Datei hilft uns, Ihre Erfahrung besser zu verstehen.',
  finalUploadLimit: 'Maximal 10 Dateien',
  finalUploadSubmit: 'SENDEN',
  finalUploadSkip: 'Uberspringen',
  finalUploadWait:
    'Bitte warten Sie, bis alle Dateien fertig hochgeladen sind',
}
export default de_DE
